<p>quote-terms-and-conditions works!</p>
